import React from 'react';

export const useBackButton = (handler) => {
  React.useEffect(() => {
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, [handler]);
};
